<template>
  <div class="data-list-parent">
    <div class="header">
      <el-tabs v-model="selectedHeader" @tab-click="handleClick" :class="selectPlate > 1 && 'graph-report'">
        <el-tab-pane label="数据来源" name="dataSource"></el-tab-pane>
        <el-tab-pane v-if="selectPlate <= 1" label="报表属性" name="reportAttr" :disabled="reportService.report.mainTableId === ''"></el-tab-pane>
      </el-tabs>
    </div>
    <div ref="tableList" class="table-list" v-if="selectedHeader==='dataSource'">
      <!-- 归档表列表 -->
      <el-row class="tac table-list" v-if="showType === 'TableList'">
        <el-col :span="24">
          <div class="search">
            <el-input v-model="keyword">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </div>
          <el-menu
            default-active="2"
            class="el-menu-vertical data-options"
            @select="clickItem">
            <el-menu-item
              v-for="(table,index) in limitTables"
              :index='table.id'
              :key="index"
            >
              <span slot="title" :title="table.name">{{table.name}}</span>
            </el-menu-item>
          </el-menu>
        </el-col>
      </el-row>
      <!-- 数据列列表 -->
      <el-row class="tac column-list" v-if="showType === 'ColumnList'">
        <el-menu
          class="el-menu-vertical"
          :unique-opened='true'
          :default-openeds="[reportService.report.mainTableId]">
          <el-submenu v-for="(selectedTable , index) in dataTables" :key="selectedTable.id" :index="selectedTable.id" :class="'a_' + selectedTable.type">
            <template slot="title">
              <span class="report-public-ellipsis" :title="selectedTable.joinType === 'dataSourceReport' ? `[辅]${selectedTable.name}` : selectedTable.name">{{selectedTable.joinType === 'dataSourceReport' ? `[辅]${selectedTable.name}` : selectedTable.name}}</span>
              <span v-if="selectedTable.joinType" class="operation-icon-container">
                  <span v-if="selectedTable.type!==4" @click.stop="addTable(selectedTable,index)" class="el-icon-plus"></span>
                  <span @click.stop="editTable(selectedTable)" class="el-icon-edit"></span>
                  <span @click.stop="delTable($event,selectedTable)" class="del-container">
                    <span class="el-icon-close"></span>
                    <span class="el-icon-error"></span>
                  </span>
                </span>
              <span v-else class="operation-icon-maintable">
                 <span @click.stop="backToChooseTable" title="添加关联表" class="el-icon-plus"></span>
               </span>
              </template>
              <el-input :ref='"searchColumn"+index'
                        class="search-column"
                        v-model="keywords[index]"
                        @focus="searchKeyword(index)"
                        prefix-icon="el-icon-search"
                        placeholder="请输入搜索的内容"
                        clearable
                        @blur="clearActive(index)"
                        @keyup.enter.native="enterEvent(index)"
                        @keyup.up.native="keyEvent(index,'up')"
                        @keyup.down.native="keyEvent(index,'down')"></el-input>
              <el-menu-item-group :ref='"itemGroup"+index'>
                <el-menu-item
                  v-for="(column,index2) in selectedTable.columns"
                  :index='column.id'
                  :key="index2"
                  v-show="column.show">
                  <span draggable="true" @dragstart="onDragStart($event, column)"
                        :title="column.name" @click="addColumn(column)">{{column.name}}</span>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </el-row>
      <!-- 图表列表 -->
      <div class="graph-setting" v-if="showType === 'GraphSetting'" ref="graphSetting">
        <div class="table-list-graph">
          <div :class="['table-item', table.joinType && 'type-data-source', 'b_' + table.type]" v-for="( table, index ) in dataTables" :key="table.id">
            <span class="name report-public-ellipsis" :title="table.name">{{ table.name }}</span>
            <span v-if="table.joinType" class="operation-icon-container">
              <span v-if="table.type!==4" @click.stop="addTable(table,index)" class="el-icon-plus"></span>
              <span @click.stop="editTable(table)" class="el-icon-edit"></span>
              <span @click.stop="delTable($event,table)" class="del-container">
                <span class="el-icon-close"></span>
                <span class="el-icon-error"></span>
              </span>
            </span>
            <!--看板不能添加子表-->
            <span v-else-if="selectPlate !== 7" class="operation-icon-maintable">
              <span @click.stop="backToChooseTable" title="添加关联表" class="el-icon-plus"></span>
            </span>
          </div>
        </div>
        <div class="graph-details">
          <template v-if="[2,3,4].includes(selectPlate)">
            <div class="graph-title">维度</div>
            <div class="dimension">
              <div :class="['graph-attr-list dimension-list', dimension.id === editGraphObj.id && editGraphObj.graphType === 'dimension' && 'active-graph-list']" v-for="(dimension, x) in graphSetting.dimension.selectList" :key="dimension.id">
                <span class="report-public-ellipsis" :title="getColumnName(dimension)">{{ getColumnName(dimension) }}</span>
                <span class="operation-graph-container">
                <span :class="['el-icon-edit', getColumnType(dimension) && 'disabled-icon-edit']" @click="editDimensionOrIndex(dimension, 'dimension')"></span>
                <span class="el-icon-error" @click="delDimensionOrIndex('dimension', x)"></span>
              </span>
                <div v-if="dimension.id === editGraphObj.id && editGraphObj.graphType === 'dimension'" class="edit-dialog-warp">
                  <div class="edit-dialog-title">日期单位</div>
                  <el-select v-model="editGraphObj.dimension.dateType" placeholder="请选择">
                    <el-option label="季度" value="QUARTER"></el-option>
                    <el-option label="年" value="YEAR"></el-option>
                    <el-option label="年、月" value="MONTH"></el-option>
                    <el-option label="年、月、日" value="DAY"></el-option>
                  </el-select>
                  <div class="edit-dialog-footer">
                    <el-button @click="saveGraphAttr('dimension')" type="primary">保存</el-button>
                    <el-button @click="closeDialogWithGraph">取消</el-button>
                  </div>
                </div>
              </div>
              <div :class="['add-dimension', showTableColumnList === 1 && 'select-add-btn', getBtnDisabled && 'disabled-add-btn']" @click.stop="addDimensionOrIndex(1)">
                <span><i class="el-icon-plus"></i>添加维度</span>
                <div v-if="showTableColumnList === 1" class="tables-column-list">
                  <el-input class="dimensionSearch" v-model="dimensionSearch"></el-input>
                  <div class="list-content">
                    <div :class="['column-list-item', graphSetting.dimension.selectList.find(s => s.id === column.id) && 'select-column-item', getDisabled(column, 'dimension') && 'disabled-column-item']" v-for="column in getDimensionalityColumn" :key="column.id" @click="selectDimensionOrIndex('dimension', column)" :title="getColumnName(column)">
                      <span>{{ getColumnName(column) }}</span>
                      <i class="el-icon-check"></i>
                    </div>
                    <div v-if="getDimensionalityColumn.length === 0" class="none">暂无数据</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="graph-title">指标</div>
            <div class="index">
              <div :class="['graph-attr-list index-list', index.id === editGraphObj.id && editGraphObj.graphType === 'graphIndex' && 'active-graph-list']" v-for="(index, x) in graphSetting.index.selectList" :key="index.id">
                <span class="report-public-ellipsis" :title="getColumnName(index)">{{ getColumnName(index) }}</span>
                <span class="operation-graph-container">
               <span class="el-icon-edit" @click="editDimensionOrIndex(index, 'graphIndex')"></span>
                <span class="el-icon-error" @click="delDimensionOrIndex('index', x)"></span>
              </span>
                <div v-if="index.id === editGraphObj.id && editGraphObj.graphType === 'graphIndex'" class="edit-dialog-warp graph-index-dialog">
                  <div class="edit-dialog-title">显示格式</div>
                  <el-select v-model="editGraphObj.graphIndex.showType" placeholder="请选择">
                    <el-option label="默认" value="默认"></el-option>
                    <el-option label="显示千分位分隔符" value="显示千分位分隔符"></el-option>
                    <el-option label="显示百分比" value="显示百分比"></el-option>
                  </el-select>
                  <div class="edit-dialog-title">显示单位</div>
                  <el-select v-model="editGraphObj.graphIndex.showUnit" placeholder="请选择">
                    <el-option label="请选择" value="请选择"></el-option>
                    <el-option label="元" value="元"></el-option>
                    <el-option label="万元" value="万元"></el-option>
                    <el-option label="件" value="件"></el-option>
                    <el-option label="%" value="%"></el-option>
                  </el-select>
                  <div class="edit-dialog-title">
                    <span>小数位数</span>
                    <el-tooltip content="填写者可选择小数位数，否则默认不限制" placement="top" class="tooltip">
                      <span class="el-icon-info"></span>
                    </el-tooltip>
                  </div>
                  <el-select v-model="editGraphObj.graphIndex.decimalDigits" placeholder="请选择限制位数">
                    <el-option label="请选择" value="请选择"></el-option>
                    <el-option label="1" value="1"></el-option>
                    <el-option label="2" value="2"></el-option>
                    <el-option label="3" value="3"></el-option>
                    <el-option label="4" value="4"></el-option>
                    <el-option label="5" value="5"></el-option>
                  </el-select>
                  <div class="edit-dialog-footer">
                    <el-button @click="saveGraphAttr('index')" type="primary">保存</el-button>
                    <el-button @click="closeDialogWithGraph">取消</el-button>
                  </div>
                </div>
              </div>
              <div :class="['add-dimension add-index', showTableColumnList === 2 && 'select-add-btn', graphSetting.index.selectList.length === 1 && showTableColumnList !== 2 && 'disabled-add-btn']" @click.stop="addDimensionOrIndex(2)">
                <span><i class="el-icon-plus"></i>添加指标</span>
                <div v-if="showTableColumnList === 2" class="tables-column-list">
                  <el-input class="dimensionSearch" v-model="indicatorSearch"></el-input>
                  <div class="list-content">
                    <div :class="['column-list-item', graphSetting.index.selectList.find(s => s.id === column.id) && 'select-column-item', getDisabled(column, 'index') && 'disabled-column-item']" v-for="column in getColumnWithNumber" :key="column.id" @click="selectDimensionOrIndex('index', column)" :title="getColumnName(column)">
                      <span>{{ getColumnName(column) }}</span>
                      <i class="el-icon-check"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-if="selectPlate===7">
            <!-- 看板属性 -->
            <div class="billboard-line">
              <label>分类列</label>
              <el-select v-model="billboardSetting.classificationColumnId" placeholder="请选择">
                  <el-option
                    v-for="column in getClassificationColumns"
                    :key="column.id"
                    :label="column.name"
                    :disabled="billboardSetting.showColumnId===column.id"
                    :value="column.id">
                  </el-option>
              </el-select>
            </div>
            <div class="billboard-line">
              <label>显示列</label>
              <el-select v-model="billboardSetting.showColumnId" placeholder="请选择">
                <el-option
                  v-for="column in getAllColumns"
                  :key="column.id"
                  :label="column.name"
                  :disabled="billboardSetting.classificationColumnId===column.id||billboardSetting.numberColumnId===column.id"
                  :value="column.id">
                </el-option>
              </el-select>
            </div>
            <div class="billboard-line">
              <label>
                排序列
                <el-tooltip class="item" effect="dark" content="需要在表单新增一个数字控件用于排序" placement="top">
                  <span class="fa fa-question-circle"></span>
                </el-tooltip>
              </label>
              <el-select v-model="billboardSetting.numberColumnId" placeholder="请选择">
                <el-option
                  v-for="column in getNumberColumns"
                  :key="column.id"
                  :label="column.name"
                  :disabled="billboardSetting.showColumnId===column.id"
                  :value="column.id">
                </el-option>
              </el-select>
            </div>
          </template>
          <div class="system-default-filter">系统默认筛选</div>
          <div class="expression">
            <filter-senior-panel ref="filterSeniorPanel" @updateSeniorFilter="updateSeniorFilter" :isGraphReport="true"></filter-senior-panel>
          </div>
        </div>
      </div>
      <div v-if="selectPlate > 1 && reportService.report.mainTableId" class="save-graph">
        <!--保存按钮-->
        <el-button :icon="isGenerateGraph ? 'el-icon-loading' : ''" :disabled="isGenerateGraph" @click="leftConfirm" type="primary">保存</el-button>
      </div>
    </div>
    <div ref='reportAttr' class="report-attr" v-if="selectedHeader==='reportAttr'">
      <panel-basic @openDataSource="openDataSource"></panel-basic>
    </div>
    <div class="bottom-button" v-if="couldReset">
      <div class="reset" @click="toQuote">
        重置
      </div>
    </div>
    <report-join-setup
      ref="reportJoinSetup"
      :tables="limitTables"
      :tableId="tableId"
      @addJoin="addJoin"
      @editJoin="editJoin"></report-join-setup>
    <div class="without-tip-dialog" v-show='info.visiable' :style="{'left':info.left+'px','top':info.top+'px'}"><p>请先删除子关联表</p></div>
  </div>
</template>

<script>
import _ from 'lodash'
import Vue from 'vue'
import ReportJoinSetup from './report-join-setup.vue'
import PanelBasic from './basic-panel.vue'
import Column from '../../../store/report/column'
import ColorFormat from '@/store/report/colorFormat.js'
import DisplayFormat from '@/store/report/displayFormat.js'
import DataFormat from '@/store/report/dataFormat.js'
import FilterSeniorPanel from './filter-senior-panel'
import Join from '@/store/report/join.js'

export default {
  name: 'DataList',
  inject: ['reportService', 'needLoad', 'reportComment'],
  props: ['selectPlate', 'graphSettingPrpos', 'id', 'reportType', 'billboardProperties'],
  components: {
    ReportJoinSetup,
    PanelBasic,
    Column,
    FilterSeniorPanel
  },
  watch: {
    async 'reportService.report.mainTableId' (val) {
      if (val) {
        if (!this.tables.length) {
          await this.loadTables()
        }
        if (this.selectPlate <= 1) {
          this.showType = 'ColumnList'
        } else {
          this.showType = 'GraphSetting'
        }
        this.joins = []
        // 处理多级从表之间的关系
        let handleJoins = _.cloneDeep(this.reportService.report.joins)
        let secondJoins = handleJoins.filter(m => m.principalTableId === this.reportService.report.mainTableId)
        let newJoins = []
        secondJoins.forEach(m => {
          m.type = 2
          newJoins.push(m)
          let thirdJoins = handleJoins.filter(n => n.principalTableId === m.referenceTableId)
          thirdJoins.forEach(n => {
            n.type = 3
            newJoins.push(n)
            let fourJoins = handleJoins.filter(el => el.principalTableId === n.referenceTableId)
            fourJoins.forEach(o => {
              o.type = 4
              newJoins.push(o)
            })
          })
        })
        this.reportService.report.joins = newJoins
        this.reportService.report.joins.forEach(el => {
          let join = {}
          join.id = el.id
          join.principalTableId = el.principalTableId
          join.principalColumnId = el.principalColumnId
          join.referenceTableId = el.referenceTableId
          join.referenceColumnId = el.referenceColumnId
          join.name = el.name
          join.use = el.use
          join.joinType = el.joinType
          join.type = el.type
          this.joins.push(new Join(join))
        })
        this.loadDataReports()
          .then(() => this.selectedTablesColumn())

        if (!this.tableId) {
          this.tableId = val
          if (this.selectPlate <= 1) {
            this.showType = 'ColumnList'
          } else {
            this.showType = 'GraphSetting'
          }
        }
      }
    },
    keywords (val) {
      this.dataTables[this.selectKeywordInput].columns.forEach(m => {
        let str = val[this.selectKeywordInput]
        if (m.name.includes(str) || (m.pinyinName && m.pinyinName.includes(str)) || (m.pinyinFirstChar && m.pinyinFirstChar.includes(str))) {
          m.show = true
        } else {
          m.show = false
        }
      })
    },
    dataTables: {
      handler (val) {
        this.reportService.options.allAchivedColumns = []
        this.dataTables.forEach(m => {
          m.columns.forEach(n => {
            this.reportService.options.allAchivedColumns.push(n)
          })
        })
      },
      deep: true
    },
    'reportService.report.joins': {
      handler (val) {
        this.joins = val
      },
      deep: true
    },
    getNeedLoad: {
      handler (val) {
        if (val > 0) {
          this.cloneDataTables = _.cloneDeep(this.dataTables)
          // 删除辅助表后切换成当前报表设计页，需要把刚刚的辅助表列更新
          this.dataTables = []
          this.loadMaintable()
            .then(() => this.loadChildTables(true))
            .then(() => {
              // 删除辅助表后切换成当前报表设计页，需要把刚刚的辅助表列更新，并且拖过的辅助表列需要删除
              let columnsAll = [].concat.apply([], this.dataTables.map(m => m.columns))
              let cloneColumnsAll = [].concat.apply([], this.cloneDataTables.map(m => m.columns))
              let removeColumns = _.differenceBy(cloneColumnsAll, columnsAll, 'id')
              this.reportService.report.columns = this.reportService.report.columns.filter(m => !removeColumns.some(n => m.expressionText.includes(n.id)))
            })
        }
      },
      deep: true,
      immediate: true
    },
    keyword (val) {
      if (val) {
        this.limitTables = this.tables.filter(t => t.name.includes(val) || (t.pinyinName && t.pinyinName.includes(val)) || (t.pinyinFirstChar && t.pinyinFirstChar.includes(val))).slice(0, 10)
      } else {
        this.limitTables = this.tables.slice(0, 10)
      }
    },
    graphSettingPrpos: {
      handler (val) {
        if (Object.keys(val).length > 0 && this.selectPlate !== 7) {
          this.graphSetting = _.cloneDeep(val)
          this.drawGraph(false)
        }
      },
      deep: true
    },
    billboardProperties: {
      handler (val) {
        if (Object.keys(val).length > 0 && this.selectPlate === 7) {
          this.billboardSetting.classificationColumnId = _.cloneDeep(val.classificationColumnId)
          this.billboardSetting.showColumnId = _.cloneDeep(val.showColumnId)
          this.billboardSetting.numberColumnId = _.cloneDeep(val.numberColumnId)
          this.loadBillbord()
        }
      },
      deep: true
    },
    graphSetting: {
      handler (val) {
        if (this.isSaveGraphAttr) {
          // 编辑
          if (Object.keys(this.graphSettingPrpos).length > 0) {
            this.isSaveGraphAttr = JSON.stringify(this.graphSettingPrpos) === JSON.stringify(this.graphSetting)
          }
          let length = val.dimension.selectList.length + val.index.selectList.length
          this.isSaveGraphAttr = length === this.reportService.report.columns.length
          this.isSaveGraphAttr && val.dimension.selectList.forEach(s => {
            this.isSaveGraphAttr = !!this.reportService.report.columns.find(c => c.columnId === s.id)
          })
          this.isSaveGraphAttr && val.index.selectList.forEach(s => {
            this.isSaveGraphAttr = !!this.reportService.report.columns.find(c => c.columnId === s.id)
          })
        }
      },
      deep: true
    }
  },
  mounted () {
    this.loadTables()
    this.loadDataReports()
    if (this.reportService.report.mainTableId) {
      this.tableId = this.reportService.report.mainTableId
      if (this.selectPlate <= 1) {
        this.showType = 'ColumnList'
      } else {
        this.showType = 'GraphSetting'
      }
    }
  },
  data () {
    return {
      columns: [],
      checked: '',
      tables: [],
      dataSourceReports: [],
      limitTables: [],
      keyword: '',
      showType: 'TableList',
      tableId: null,
      joins: [],
      selectedHeader: 'dataSource',
      keywords: [],
      selectKeywordInput: 0,
      dataTables: [],
      cloneDataTables: [],
      addJoinObj: {},
      showTableColumnList: 0,
      graphSetting: {
        // 维度
        dimension: {
          selectList: []
        },
        // 指标
        index: {
          selectList: []
        }
      },
      billboardSetting: {
        //  分类列字段id
        classificationColumnId: '',
        //  展示列字段id
        showColumnId: '',
        //  排序列展示字段id
        numberReportColumnId: ''
      },
      editGraphObj: {},
      isGenerateGraph: false,
      isSaveGraphAttr: true,
      joinIndex: -1,
      currentJoinId: '',
      info: {
        visiable: false,
        left: 0,
        top: 0
      },
      editJoinObj: {},
      columnListIndex: '1',
      //  维度搜索值
      dimensionSearch: '',
      //  指标搜索值
      indicatorSearch: ''
    }
  },
  methods: {
    loadTables () {
      return this.$axios.get('/report-api/report/definition/tables')
        .then(res => {
          if (res.data) {
            this.limitTables = res.data.slice(0, 10)
            this.tables = res.data
            this.reportService.options.tables = this.tables
          }
        })
    },
    loadDataReports () {
      return this.$axios.get(`/report-api/report/definition/dataSourceReports`).then((res) => {
        this.reportService.options.dataSourceReports = res.data
        this.dataSourceReports = res.data
      })
    },
    // 点击列表选项事件
    clickItem (index) {
      // 防止多次点击
      if (this.tableId) {
        return false
      }
      this.tableId = index
      this.reportService.loadTargetPromise(index).then(() => {
        // 按钮没有指向的加上
        this.reportService.report.buttons.forEach(button => {
          if (!button.targetId) {
            button.targetType = this.reportService.options.processTargetId ? 'flow' : 'form'
            button.targetId = button.targetType === 'form' ? this.reportService.options.formTargetId : this.reportService.options.processTargetId
          }
        })
      })
      this.loadTableColumns(index)
      // 每次点击的时候都要重置 joins
      this.joins = []
      this.limitTables = this.tables.slice(0, 10)
      // 加载自带的从表 可能以后又要用
      // this.$axios.get('/data-api/relations/', {params: {tableId: this.tableId}})
      //   .then(res => {
      //     // 改变重新统计数据
      //     res.data.forEach(el => {
      //       let join = {use: true}
      //       join.principalTableId = el.principalTableId
      //       // join.id = el.id
      //       // 不知道为什么要用自带的id，现修改为UUID
      //       join.id = UUID.create()
      //       join.principalColumnId = el.principalColumnId
      //       join.referenceTableId = el.tableId
      //       join.referenceColumnId = el.columnId
      //       join.name = el.tableName
      //       join.joinType = el.joinType
      //       this.joins.push(join)
      //       this.loadTableColumns(el.tableId)
      //     })
      //     this.$nextTick(() => this.loadColumn())
      //   })
      this.$nextTick(() => this.loadColumn())
    },
    loadTableColumns (tableId) {
      return new Promise((resolve, reject) => {
        let table = this.tables.find(m => m.id === tableId)
        if (table) {
          this.$axios.get(`/data-api/table/${tableId}`)
            .then(data => {
              data.data.columns.forEach(m => {
                m.show = true
              })
              Vue.set(table, 'columns', data.data.columns)
              Vue.set(table, 'filters', data.data.filters)
              resolve(table)
            })
        }
      })
    },
    loadDataSourceReportsColumns (reportId) {
      return new Promise((resolve, reject) => {
        let dataSourceReport = this.dataSourceReports.find(m => m.id === reportId)
        if (dataSourceReport) {
          this.$axios.get(`/report-api/report/definition/${reportId}?type=edit`)
            .then(res => {
              res.data.columns.forEach(m => {
                m.show = true
              })
              Vue.set(dataSourceReport, 'columns', res.data.columns)
              Vue.set(dataSourceReport, 'filters', res.data.filters)
              resolve(dataSourceReport)
            })
        }
      })
    },
    // 头部点击事件
    handleClick (tab, event) {
      this.selectedHeader = tab.name
    },
    openDataSource () {
      this.selectedHeader = 'dataSource'
    },
    backToChooseTable () {
      this.joinIndex = -1
      this.$refs.reportJoinSetup.openDialog('添加关联')
    },
    loadColumn () {
      return new Promise(resolve => {
        // 这一步会吧真正的join new一遍
        this.reportService.addJoins(this.joins)
        // 第一引用主表的时候mainTableId不存在通过监听this.reportService.report.mainTableId的值改变，加载全部的归档表
        if (this.reportService.report.mainTableId) {
          this.selectedTablesColumn()
        }
        this.reportService.initReportColumn(this.tableId)
        if (this.selectPlate <= 1) {
          this.showType = 'ColumnList'
        } else {
          this.showType = 'GraphSetting'
        }
        this.$nextTick(() => resolve())
      })
    },
    async addColumn (column) {
      if (column) {
        let pingyin = await this.reportService.getPinyinByHanzi(column.name)
        _.merge(column, {...pingyin})
        let reportColumn = Column.create(column)
        reportColumn.columnType = column.dataType || column.columnType
        let colorFormat = new ColorFormat()
        reportColumn.format.colorFormats.push(colorFormat)
        let displayFormat = new DisplayFormat()
        reportColumn.format.displayFormats.push(displayFormat)
        reportColumn.format.dataFormat = new DataFormat()
        this.reportService.createOrUpdate(reportColumn)
        this.reportService.report.columns && this.reportService.report.columns.length > 3 && this.$emit('scrollRight')
      }
    },
    // 拖拽开始
    onDragStart (event, column) {
      column.type = 'table'
      event.dataTransfer.setData('text', JSON.stringify(column))
    },
    // 增加关联关系
    addJoin (join) {
      // 判断是不是存在相同个关联,如果存在, 不在添加了
      let sameJoin = this.joins.find(m => {
        return m.principalTableId === join.principalTableId &&
            m.referenceTableId === join.referenceTableId &&
            m.principalColumnId === join.principalColumnId &&
            m.referenceColumnId === join.referenceColumnId
      })
      if (!sameJoin) {
        if (this.joinIndex === -1) {
          join.type = 2
          let newJoin = new Join(join)
          this.joins.push(newJoin)
        } else {
          let parentJoin = this.reportService.report.joins.find(j => j.id === this.currentJoinId)
          let childJoins = []
          if (parentJoin) {
            childJoins = this.findChildJoins(parentJoin, [])
          }
          let newJoin = new Join(join)
          this.joins.splice(this.joinIndex + childJoins.length, 0, newJoin)
        }
        this.loadColumn().then(res => this.$refs.reportJoinSetup.cancel())
      } else {
        this.$message('请勿添加重复的关联表')
      }
    },
    searchKeyword (index) {
      this.selectKeywordInput = index
    },
    loadChildTables (flag) {
      // 加载从表是辅助表和归档表的列
      let tasks = this.reportService.report.joins.map(m => {
        if (m.joinType && m.joinType !== 'archived') {
          let dataSourcereport = _.cloneDeep(this.dataSourceReports.find(n => n.id === m.referenceTableId))
          if (dataSourcereport) {
            dataSourcereport.joinType = 'dataSourceReport'
            dataSourcereport.type = m.type
            dataSourcereport.relationId = m.id
            dataSourcereport.name = m.name ? m.name : dataSourcereport.name
            dataSourcereport.columns = []
            this.dataTables.push(dataSourcereport)
            return this.loadDataSourceReportsColumns(m.referenceTableId).then((data) => {
              dataSourcereport.columns = data.columns
              dataSourcereport.columns.forEach(el => {
                el.relationId = dataSourcereport.relationId
                el.show = true
              })
            })
          }
        } else {
          let table = _.cloneDeep(this.tables.find(n => n.id === m.referenceTableId))
          if (table) {
            table.joinType = 'archived'
            table.type = m.type
            table.relationId = m.id
            table.name = m.name ? m.name : table.name
            table.columns = []
            this.dataTables.push(table)
            return this.loadTableColumns(m.referenceTableId).then((data) => {
              table.columns = data.columns
              table.columns.forEach(el => {
                el.relationId = table.relationId
                el.show = true
              })
            })
          }
        }
      })
      return flag ? Promise.all(tasks) : Promise.resolve()
    },
    loadMaintable () {
      return new Promise(resolve => {
        let mainTable = _.cloneDeep(this.tables
          .find(m => m.id === this.reportService.report.mainTableId))
        if (mainTable) {
          mainTable.relationId = mainTable.id
          this.loadTableColumns(this.reportService.report.mainTableId).then((data) => {
            mainTable.columns = data.columns
            this.dataTables.unshift(mainTable)
            resolve()
          })
        }
      })
    },
    selectedTablesColumn () {
      this.dataTables = []
      this.loadMaintable()
      this.loadChildTables()
    },
    addTable (table, index, type) {
      this.joinIndex = index
      this.addJoinObj = {principalTableId: table.id, type: table.type + 1}
      this.currentJoinId = table.relationId
      this.$refs.reportJoinSetup.openDialog('添加关联', this.addJoinObj)
    },
    editTable (table) {
      let join = this.$_.cloneDeep(this.joins.find(j => j.id === table.relationId))
      this.editJoinObj = join
      this.$refs.reportJoinSetup.openDialog('编辑', join)
    },
    editJoin (join) {
      if (this.editJoinObj.referenceTableId !== join.referenceTableId) {
        let removeJoins = this.findChildJoins(this.editJoinObj, [])
        if (removeJoins.length) {
          this.$message.info('请删除子关联表')
          return false
        }
      }
      this.reportService.createOrUpdate(join)
      this.$nextTick(() => {
        this.$refs.reportJoinSetup.cancel()
        this.loadColumn()
      })
    },
    // 查找关联表的使用
    findJoinsUsages (table) {
      // 现在默认排序,分组统计,系统默认筛选,筛选条件中会引用到
      let isUsingOptions = []
      let orderBiesUsages = []
      let groupBiesUsages = []
      let seniorFiltersUsages = []
      let ordinaryFiltersUsages = []
      let join = this.joins.find(j => j.id === table.relationId)
      // 根据表列来查找,在默认排序,分组统计,系统默认筛选和筛选条件中使用了的列,再根据他们的expressionText来查找是否是关联表列
      this.reportService.report.columns.forEach(col => {
        if (this.reportService.report.orderBies.find(n => n.columnId === col.id)) {
          orderBiesUsages.push(col.expressionText)
        }
        if (this.reportService.report.groupBies.find(n => n.columnId === col.id)) {
          groupBiesUsages.push(col.expressionText)
        }
        if (this.reportService.report.filters.find(n => n.columnId === col.id && n.filterType === 'senior')) {
          seniorFiltersUsages.push(col.expressionText)
        }
        if (this.reportService.report.filters.find(n => n.columnId === col.id && n.filterType !== 'senior')) {
          ordinaryFiltersUsages.push(col.expressionText)
        }
      })
      if (orderBiesUsages.join().includes(join.id)) {
        isUsingOptions.push('默认排序')
      }
      if (groupBiesUsages.join().includes(join.id)) {
        isUsingOptions.push('分组统计')
      }
      // 普通筛选
      if (!this.reportService.report.systemFilterSwitch && seniorFiltersUsages.join().includes(join.id)) {
        isUsingOptions.push('系统默认筛选')
      } else if (this.reportService.report.systemFilterSwitch && this.reportService.report.filterExpression.includes(join.id)) {
        // 高级筛选
        isUsingOptions.push('系统默认筛选')
      }
      if (ordinaryFiltersUsages.join().includes(join.referenceColumnId)) {
        isUsingOptions.push('筛选条件')
      }
      return isUsingOptions
    },
    delTable (event, table) {
      this.info.left = event.clientX + 40
      this.info.top = event.clientY
      let isUsingOptions = this.findJoinsUsages(table)
      if (isUsingOptions.length > 0) {
        return this.$msgbox({
          title: '',
          message: `该报表在${isUsingOptions.join('、')}中被引用, 请确认该表没有被引用再删除?`,
          center: true,
          showCancelButton: false,
          confirmButtonText: '关 闭',
          customClass: 'withoutConfirmMsgbox'
        })
      } else {
        this.$confirm('', '您确定删除吗？', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          customClass: 'deleMessageBox',
          distinguishCancelAndClose: true,
          center: true
        }).then(() => {
          let join = this.reportService.report.joins.find(j => j.id === table.relationId)
          let removeJoins = this.findChildJoins(join, [])
          if (removeJoins.length > 0) {
            this.info.visiable = true
            if (this.info.timer) {
              clearTimeout(this.info.timer)
            }
            this.info.timer = setTimeout(() => {
              this.info.visiable = false
              clearTimeout(this.info.timer)
            }, 3000)
            return false
          }
          let index = this.joins.findIndex(j => j.id === join.id)
          this.joins.splice(index, 1)
          // 删除没有被引用的数据列
          this.reportService.report.columns = this.reportService.report.columns.filter(m => !m.expressionText.includes(join.id))
          let referenceTableId = join.referenceTableId
          // 删除的joins
          // 下级的从表直接删除
          // removeJoins.forEach(m => {
          //   let index = this.joins.findIndex(j => j.id === m.id)
          //   this.joins.splice(index, 1)
          // })
          // 删除关联表之后，需要把选择的维度和指标也删除
          if (referenceTableId) {
            let dimension = this.graphSetting.dimension.selectList.filter(s => s.tableId !== referenceTableId)
            let graphIndex = this.graphSetting.index.selectList.filter(s => s.tableId !== referenceTableId)
            this.$set(this.graphSetting.dimension, 'selectList', dimension)
            this.$set(this.graphSetting.index, 'selectList', graphIndex)
          }
          this.$nextTick(() => this.loadColumn())
        })
      }
    },
    findChildJoins (join, childJoins) {
      this.reportService.report.joins.forEach(m => {
        if (m.principalTableId === join.referenceTableId) {
          childJoins.push(m)
          this.findChildJoins(m, childJoins)
        }
      })
      return childJoins
    },
    updateSeniorFilter (seniorFilter) {
      if (seniorFilter && seniorFilter.filters) {
        this.reportService.report.filters = this.reportService.report.filters.filter(m => m.filterType !== 'senior')
        seniorFilter.filters.forEach(m => {
          this.reportService.createOrUpdate(m)
        })
      }
      // 特殊处理默认筛选和高级筛选。高级筛选为更新筛选项
      if (this.reportService.report.filterExpression !== seniorFilter.expression) {
        this.reportComment.changeFilter = true
      }
      this.reportService.report.systemFilterSwitch = seniorFilter.systemFilterSwitch
      this.reportService.report.filterExpression = seniorFilter.expression
    },
    // 1: dimension
    // 2: index
    addDimensionOrIndex (flag) {
      if (flag === 1) {
        if (this.selectPlate === 2 || this.selectPlate === 4) {
          if (this.graphSetting.dimension.selectList.length !== 2) {
            this.showTableColumnList = flag
          }
        } else {
          if (this.graphSetting.dimension.selectList.length !== 1) {
            this.showTableColumnList = flag
          }
        }
      } else {
        if (this.graphSetting.index.selectList.length !== 1) {
          this.showTableColumnList = flag
        }
      }
      this.$nextTick(() => {
        document.querySelector('.tables-column-list') && document.querySelector('.tables-column-list').addEventListener('mouseleave', () => {
          if (this.showTableColumnList > 0) {
            this.showTableColumnList = 0
            this.dimensionSearch = ''
            this.indicatorSearch = ''
          }
        })
      })
    },
    selectDimensionOrIndex (type, column) {
      let index = this.graphSetting[type].selectList.findIndex(s => s.id === column.id)
      if (index !== -1) {
        this.graphSetting[type].selectList.splice(index, 1)
      } else {
        // 维度最多只能添加两个
        // 指标只能添加一个
        let data = {...column}
        let columnType = data.dataType || data.columnType
        data.dimension = { dateType: columnType.toUpperCase() === 'DATE' || columnType.toUpperCase() === 'DATETIME' ? 'MONTH' : '' }
        data.graphIndex = {
          showType: '默认',
          showUnit: '',
          decimalDigits: ''
        }
        data.graphType = type
        if (type === 'index') {
          if (this.graphSetting[type].selectList.length === 0) {
            this.graphSetting[type].selectList.push({...data})
            this.scrollDown()
          }
        } else {
          if (this.selectPlate === 2 || this.selectPlate === 4) {
            if (this.graphSetting[type].selectList.length <= 1) {
              this.graphSetting[type].selectList.push({...data})
              this.scrollDown()
            }
          } else {
            if (this.graphSetting[type].selectList.length === 0) {
              this.graphSetting[type].selectList.push({...data})
              this.scrollDown()
            }
          }
        }
      }
      this.dimensionSearch = ''
      this.indicatorSearch = ''
      this.showTableColumnList = 0
    },
    scrollDown () {
      this.$nextTick(() => {
        let scroll = this.$refs.graphSetting
        if (scroll.scrollHeight > scroll.clientHeight) {
          scroll.scrollTop = scroll.scrollTop + 38
        }
      })
    },
    editDimensionOrIndex (data, graphType) {
      let type = data.dataType || data.columnType
      // 非时间类型维度不可编辑
      if (graphType.toLowerCase() === 'dimension') {
        if (type.toUpperCase() !== 'DATE' && type.toUpperCase() !== 'DATETIME') {
          return false
        }
      }
      this.editGraphObj = {..._.cloneDeep(data), ...{graphType}}
    },
    delDimensionOrIndex (type, x) {
      this.graphSetting[type].selectList.splice(x, 1)
    },
    closeDialogWithGraph () {
      this.$set(this, 'editGraphObj', {dimension: {}, graphIndex: {}})
    },
    saveGraphAttr (type) {
      let source = this.graphSetting[type].selectList.find(s => s.id === this.editGraphObj.id)
      if (type === 'index') {
        this.$set(source, 'graphIndex', {...this.editGraphObj.graphIndex})
      } else {
        this.$set(source, type, {...this.editGraphObj[type]})
      }
      this.$set(this, 'editGraphObj', {dimension: {}, graphIndex: {}})
    },
    leftConfirm () {
      this.selectPlate === 7 ? this.runningBillboard() : this.runningGraph(false)
    },
    // 运行图形报表
    runningGraph (shouldJudge = false, shouldHint = true) {
      return new Promise(async resolve => {
        if (!shouldJudge) {
          if (this.isGenerateGraph) {
            return false
          }
          this.isGenerateGraph = true
        }
        let arr = this.getTablesColumns() || []
        let arrLength = arr.length
        let list = [..._.merge([], this.graphSetting.dimension.selectList), ..._.merge([], this.graphSetting.index.selectList)]
        let reportColumns = this.reportService.report.columns
        if (reportColumns && reportColumns.length > 0) {
          // 构建过的列不需要再次构建
          reportColumns = reportColumns.filter(f => arr.find(a => a.id === f.columnId) !== undefined)
        }
        // 只需要增加新加的列即可
        arr = arr.filter(f => reportColumns.find(a => a.columnId === f.id) === undefined)
        // 如果列不存在了 则需要把筛选项也删除
        let reportFilters = _.merge([], this.reportService.report.filters)
        reportFilters = reportFilters.filter(f => reportColumns.find(r => f.columnId === r.id) === undefined)
        // 删除筛选项
        if (reportFilters && reportFilters.length > 0) {
          // 为什么要用 el-container ？？？ 一个 el-container一个$parent
          let reportFilter = this.$parent.$parent.$parent.$refs.reportFilter
          reportFilters.forEach(u => reportFilter.removeFilter(u))
        }
        if (arr && arr.length) {
          arr.forEach(async column => {
            await this.addColumn(column)
          })
          let unWatch = this.$watch(() => this.reportService.report.columns.length, length => {
            if (length === arrLength) {
              let columnList = _.merge([], this.reportService.report.columns)
              columnList && columnList.forEach(column => {
                let item = list.find(a => a.id === column.columnId)
                if (item) { item.reportColumnId = column.id }
              })
              // 维度
              let dimensionality = []
              // 指标
              let norm = {}
              list.forEach(item => {
                if (item.graphType === 'index') {
                  let obj = _.cloneDeep(item)
                  obj.norm = obj.graphIndex
                  obj.columnId = obj.id
                  norm = {...obj}
                } else {
                  let obj = _.cloneDeep(item)
                  obj.unit = obj.dimension.dateType
                  obj.columnId = obj.id
                  dimensionality.push(obj)
                }
              })
              this.reportService.report.dimensionality = dimensionality
              this.reportService.report.norm = norm
              this.$nextTick(async () => {
                await this.drawGraph(shouldHint)
                this.isGenerateGraph = false
                this.isSaveGraphAttr = true
                resolve()
                unWatch()
              })
            }
          }, {deep: true})
        } else {
          let dimensionality = []
          let norm = {}
          let columnList = _.merge([], this.reportService.report.columns)
          columnList && columnList.forEach(column => {
            let item = list.find(a => a.id === column.columnId)
            if (item) { item.reportColumnId = column.id }
          })
          list.forEach(item => {
            if (item.graphType === 'index') {
              let obj = _.cloneDeep(item)
              obj.norm = obj.graphIndex
              obj.columnId = obj.id
              norm = {...obj}
            } else {
              let obj = _.cloneDeep(item)
              obj.unit = obj.dimension.dateType
              obj.columnId = obj.id
              dimensionality.push(obj)
            }
          })
          this.reportService.report.dimensionality = dimensionality
          this.reportService.report.norm = norm
          await this.drawGraph(shouldHint)
          this.isGenerateGraph = false
          this.isSaveGraphAttr = true
        }
      })
    },
    // 获取报表数据，然后绘制
    async drawGraph (shouldHint) {
      await this.$emit('drawGraph', shouldHint)
    },
    getTablesColumns () {
      let tables = this.dataTables
      let columns = []
      if (tables && tables.length > 0) {
        tables.forEach(t => {
          if (t.columns && t.columns.length > 0) {
            let col = _.merge([], t.columns)
            col.forEach(c => {
              c.tableId = t.tableId
              // 后期可能需要加上
              // c.tableName = t.id !== this.reportService.report.mainTableId ? t.name : ''
            })
            columns = [...columns, ...col]
          }
        })
      }
      return columns
    },
    //  51th:回车事件
    async enterEvent (index) {
      let showList = this.dataTables[index].columns.filter(n => n.show)
      if (showList.length === 1) {
        await this.addColumn(showList[0])
        this.$refs[`searchColumn${index}`][0].clear()
      } else {
        let parent = this.$refs[`itemGroup${index}`][0].$el
        let list = [...parent.getElementsByTagName('li')].filter(n => {
          return n.style.display !== 'none'
        })
        let activeIndex
        list.forEach((n, index) => {
          if (n.classList.contains('is-active') === true) {
            activeIndex = index
          }
        })
        if (activeIndex || activeIndex === 0) {
          await this.addColumn(showList[activeIndex])
        }
      }
    },
    //  51th:↑↓事件
    keyEvent (index, type = 'down') {
      let parent = this.$refs[`itemGroup${index}`][0].$el
      let list = [...parent.getElementsByTagName('li')].filter(n => {
        return n.style.display !== 'none'
      })
      //  获取展示的下拉选项
      let next = null
      if (type === 'up') {
        next = list[list.length - 1]
      } else if (type === 'down') {
        next = list[0]
      }
      if (!list.length) return
      list.forEach((n, index) => {
        if (n.classList.contains('is-active') === true) {
          if (type === 'up') {
            next = list[list.length - 1]
            next = list[index - 1] ? list[index - 1] : list[list.length - 1]
          } else if (type === 'down') {
            next = list[index + 1] ? list[index + 1] : list[0]
          }
        }
      })
      this.clearActive(index, parent)
      next.classList.add('is-active')
    },
    //  51th：失焦事件
    clearActive (index, parent) {
      if (!parent) {
        parent = this.$refs[`itemGroup${index}`][0].$el
      }
      let oldActive = [...parent.getElementsByClassName('is-active')]
      oldActive.forEach(n => {
        n.classList.remove('is-active')
      })
    },
    //  重新引用
    toQuote () {
      this.$emit('resetReport')
    },
    //  运行看板
    runningBillboard () {
      if (this.isGenerateGraph) {
        return false
      }
      this.isGenerateGraph = true
      //  获取看板所需数据
      let billboardData = this.getColumnsData()
      if (billboardData) {
        this.reportService.report.kanBanProperties = billboardData
        //  不用promise根本无法先addColumn再build
        new Promise((resolve, reject) => {
          this.addBillboardColumns(resolve, reject)
        })
          .then(() => { this.updateBillboardProperties() })
          .then(() => { this.loadBillbord() })
      }
    },
    //  更新看板属性
    updateBillboardProperties () {
      let columns = this.reportService.report.columns
      //  会出现长度不一的情况
      let classificationColumnId = this.billboardSetting.classificationColumnId
      let showColumnId = this.billboardSetting.showColumnId
      let numberColumnId = this.billboardSetting.numberColumnId
      let classification = {}
      let show = {}
      let number = {}
      columns.forEach(n => {
        if (n.columnId === classificationColumnId) {
          classification = n
        }
        if (n.columnId === showColumnId) {
          show = n
        }
        if (n.columnId === numberColumnId) {
          number = n
        }
      })
      let obj = this.getColumnsData()
      //  重新渲染数据
      obj.classReportColumnId = classification.id
      obj.showReportColumnId = show.id
      obj.numberReportColumnId = number.id
      this.reportService.report.kanBanProperties = obj
    },
    async addBillboardColumns (resolve, reject) {
      if (this.reportService.report.columns.length) {
        resolve()
      } else {
        let list = this.getAllColumns
        await Promise.all(list.map(item => this.addBillboardColumn(item)))
          .then((columns) => {
            columns.forEach(m => {
              this.reportService.createOrUpdate(m)
            })
          }).then(() => {
            resolve()
          })
      }
    },
    addBillboardColumn (column) {
      //  看板用addColumn
      return new Promise(async (resolve) => {
        if (column) {
          let pingyin = await this.reportService.getPinyinByHanzi(column.name)
          _.merge(column, {...pingyin})
          let reportColumn = Column.create(column)
          reportColumn.columnType = column.dataType || column.columnType
          let colorFormat = new ColorFormat()
          reportColumn.format.colorFormats.push(colorFormat)
          let displayFormat = new DisplayFormat()
          reportColumn.format.displayFormats.push(displayFormat)
          reportColumn.format.dataFormat = new DataFormat()
          this.$nextTick(() => {
            resolve(reportColumn)
          })
        }
      })
    },
    //  获取看板分类列，显示列信息
    getColumnsData () {
      let xId = this.billboardSetting.classificationColumnId
      let yId = this.billboardSetting.showColumnId
      let numberId = this.billboardSetting.numberColumnId
      if (!xId) {
        this.$message.error('请选择分类列')
        this.isGenerateGraph = false
        return false
      } else if (!yId) {
        this.$message.error('请选择显示列')
        this.isGenerateGraph = false
        return false
      } else if (!numberId) {
        this.$message.error('请选择排序列')
        this.isGenerateGraph = false
        return false
      } else {
        let x = this.getAllColumns.filter(n => n.id === xId)[0]
        let y = this.getAllColumns.filter(n => n.id === yId)[0]
        return {
          //  分类列的表id
          classificationTableId: x.tableId,
          //  分类列字段id
          classificationColumnId: xId,
          //  分类列报表id
          classReportColumnId: '',
          //  展示列的表id
          showColumnTableId: y.tableId,
          //  展示列字段id
          showColumnId: yId,
          //  展示列报表id
          showReportColumnId: '',
          //  主表tableId
          mainTableId: this.dataTables[0].tableId,
          //  排序列字段id
          numberColumnId: numberId,
          //  排序列报表id
          numberReportColumnId: ''

        }
      }
    },
    //  走接口获取看板数据并渲染
    async loadBillbord () {
      let data = this.reportService.build()
      delete data.kanBanPropertiesStr
      if (this.$refs.filterSeniorPanel) {
        this.reportService.report.systemFilterSwitch = this.$refs.filterSeniorPanel.systemFilterSwitch
      }
      //  report中columns跟现有的不太一样
      await this.$axios.post(`/report-api/report/data/kanBanReportData`, data).then((res) => {
        let resultData = res.data
        let numberReportColumnId = data.kanBanProperties.numberReportColumnId
        resultData.forEach(n => {
          if (n.value.length) {
            let hasSub = []
            let noSub = []
            //  给数据分类。先展示有排序的。再展示未排序的
            n.value.forEach(item => {
              if (item[numberReportColumnId] || item[numberReportColumnId] === 0) {
                hasSub.push(item)
              } else {
                noSub.push(item)
              }
            })
            //  根据数字正序排序
            hasSub = hasSub.sort((a, b) => parseInt(a[numberReportColumnId]) - parseInt(b[numberReportColumnId]))
            n.value = [].concat(hasSub, noSub)
            //  重新排序
            let num = 0
            n.value.forEach(item => {
              item[numberReportColumnId] = num
              num++
            })
          }
        })
        this.isGenerateGraph = false
        this.$emit('updateBillboard', resultData)
      }).catch(() => { this.isGenerateGraph = false })
    }
  },
  computed: {
    selectedTable () {
      return this.tables.find(m => m.id === this.tableId)
    },
    getNeedLoad () {
      return this.needLoad.value
    },
    getAllColumns () {
      let tables = this.dataTables
      let columns = []
      if (tables && tables.length > 0) {
        tables.forEach(t => {
          if (t.columns && t.columns.length > 0) {
            let col = _.merge([], t.columns)
            col.forEach(c => {
              c.tableId = t.tableId
              // 后期可能需要加上
              // c.tableName = t.id !== this.reportService.report.mainTableId ? t.name : ''
            })
            columns = [...columns, ...col]
          }
        })
      }
      return columns
    },
    getDimensionalityColumn () {
      if (this.dimensionSearch) {
        let value = this.dimensionSearch
        return this.getAllColumns.filter(c => c.name.includes(value) || c.pinyinFirstChar.includes(value) || c.pinyinName.includes(value))
      } else {
        return this.getAllColumns
      }
    },
    getClassificationColumns () {
      //  根据里面的数据类型,进行筛选.分类只能选下拉框类型
      let list = this.getAllColumns
      return list.filter(n => n.dataType === 'ENUM')
    },
    getNumberColumns () {
      //  根据里面的数据类型,进行筛选.排序列只能选数字框类型
      let list = this.getAllColumns
      return list.filter(n => n.dataType === 'DECIMAL0')
    },
    getDisabled (column, type) {
      return (column, type) => {
        let index = this.graphSetting[type].selectList.findIndex(s => s.id === column.id)
        if (index === -1) {
          if (type === 'index') {
            return this.graphSetting[type].selectList.length === 1
          } else {
            if (this.selectPlate === 2 || this.selectPlate === 4) {
              return this.graphSetting[type].selectList.length > 1
            } else {
              return this.graphSetting[type].selectList.length > 0
            }
          }
        }
        return false
      }
    },
    getBtnDisabled () {
      if (this.selectPlate === 2 || this.selectPlate === 4) {
        return this.graphSetting.dimension.selectList.length === 2 && this.showTableColumnList !== 1
      } else {
        return this.graphSetting.dimension.selectList.length === 1 && this.showTableColumnList !== 1
      }
    },
    getColumnType (data) {
      return data => {
        let type = data.dataType || data.columnType
        return type.toUpperCase() !== 'DATE' && type.toUpperCase() !== 'DATETIME'
      }
    },
    getColumnWithNumber () {
      let columnType = ['int', 'bigint', 'decimal', 'decimal0', 'decimal1', 'decimal2', 'decimal3', 'decimal4', 'decimal5']
      let allColumns = this.getAllColumns || []
      let columns = allColumns.length ? allColumns.filter(a => {
        if (a.columnType) {
          return columnType.includes(a.columnType.toLowerCase())
        } else if (a.dataType) {
          return columnType.includes(a.dataType.toLowerCase())
        }
      }) : []
      let idColumns = allColumns.filter(c => {
        let type = c.dataType || c.columnType
        return type.toUpperCase() === 'IDENTITY' && c.primaryKey
      })
      let count = idColumns && idColumns.length > 0 ? {...idColumns[0]} : null
      if (count) {
        count.name = '数据总量'
        count.summaryType = 'COUNT'
      }
      columns.unshift({...count})
      if (this.indicatorSearch) {
        let value = this.indicatorSearch
        return columns.filter(c => c.name.includes(value) || c.pinyinFirstChar.includes(value) || c.pinyinName.includes(value))
      } else {
        return columns
      }
    },
    // 这个计算先留着，鬼知道后面会不会又要加上表名
    getColumnName () {
      return item => {
        return item.tableName ? `${item.tableName}-${item.name}` : item.name
      }
    },
    couldReset () {
      if (this.selectedHeader === 'dataSource' && !this.id && [0, 1, 2].includes(this.reportType) && this.dataTables.length < 2 && this.showType !== 'TableList') {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss">
  .data-list-parent {
    height: 100%;
    .header {
      height: 38px;
      background-color: #ebf6ff;
      .el-tabs__nav {
        width: 100%;
        .el-tabs__active-bar{
          display: none;
        }
        .el-tabs__item, .is-top {
          width: 50%;
          text-align: center;
          padding: 0;
          border-bottom: 2px solid transparent;
          &.is-active{
            border-bottom: 2px solid #409EFF;
          }
        }
        .el-tabs__item:after {
          content: '';
          width: 1px;
          height: 24px;
          background: #d6e8f6;
          position: absolute;
          right: 0;
          top: 8px;
        }
      }
      .graph-report {
        .el-tabs__header {
          .el-tabs__nav-wrap {
            .el-tabs__nav {
              #tab-dataSource {
                width: 100%;
              }
            }
          }
        }
      }
    }
    .operation-icon-maintable {
       position: absolute;
       right: 16px;
      span {
        font-size: 12px;
        width: 11px;
        height: 11px;
        color: #B6B8B9;
      }
     .el-icon-plus {
        &:hover {
          color: #8ECAF9;
        }
        &:active {
          color: #388DD2;
        }
      }
    }
    .operation-icon-container {
      position: absolute;
      right: 16px;
      display: none;
      span {
        font-size: 12px;
        width: 11px;
        height: 11px;
        color: #B6B8B9;
      }

      .del-container {
        span {
          width: 12px;
          height: 12px;
        }
        .el-icon-error {
          display: none;
        }
        &:hover {
          .el-icon-error {
            display: inline-block;
            color: #FB9391;
            &:active {
              color: #EE5451;
            }
          }
          .el-icon-close {
            display: none;
          }
        }
      }
      .el-icon-plus {
        &:hover {
          color: #8ECAF9;
        }
        &:active {
          color: #388DD2;
        }
      }
      .el-icon-edit {
        &:hover {
          color: #8ECAF9;
        }
        &:active {
          color: #388DD2;
        }
      }
    }
    .report-public-ellipsis {
      display: inline-block;
      width: calc(100% - 50px);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .report-attr {
      height: calc(100% - 50px);
    }
    .column-list.el-row, .table-list .data-options {
      max-height: 630px;
      height: 100%;
      overflow-y: auto;
    }
    .column-list {
      li {
      > span {
        width: 150px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
        }
      .add-requirement{
        display: none;
        }
      }

      li.el-menu-item:hover{
        .add-requirement{
          display: inline-block;
          line-height: 25px;
        }
      }
      .search-column {
       width: 226px;
       margin-left: 10px;
       margin-top: 10px;
      }
      ul {
        height: 100%;
      }

      .el-menu-vertical {
        .is-opened {
          margin-bottom: 5px;
          .el-menu--inline {
            height: calc(100% - 40px);
            .el-menu-item-group {
              height: calc(100% - 50px);
            }
          }
        }
        .el-submenu {
          .el-submenu__title {
            position: relative;
            padding-left: 22px!important;
            .el-submenu__icon-arrow {
              right: calc(100% - 20px);
              top: 55%;
            }
            &:hover {
              & > .operation-icon-container {
                display: inline-block;
              }
            }
          }
          &.a_2 {
          .el-submenu__title {
            padding-left: 36px !important;
            .el-submenu__icon-arrow{
             right: calc(100% - 34px);
            }
          }
         }
         &.a_3 {
          .el-submenu__title {
            padding-left: 48px !important;
            .el-submenu__icon-arrow{
             right: calc(100% - 46px);
            }
          }
         }
        &.a_4 {
          .el-submenu__title {
            padding-left: 58px !important;
            .el-submenu__icon-arrow{
            right: calc(100% - 56px);
            }
          }
         }
        }
      }
    }
    .table-list {
      height: calc(100% - 88px);
      .el-col-24 {
        height: 100%;
      }
      .search {
        margin-left: 11px;
        margin-top: 10px;
        height: 28px;
        input {
          height: 28px;
          width: 223px;
          border: 1px solid #c2c3c4;
        }
      }
      .data-options {
        margin-top: 6px;
        padding-left: 7px;
        overflow-y: auto;
        overflow-x: hidden;
        li {
          height: 30px;
          line-height: 30px;
          padding: 0;
          width: 226px;
          margin: 0px;
          border-bottom: 1px solid #f1f1f1;
          span {
            font-size: 12px;
          }
        }
        li:active {
          background-color: #c5e4fe;
        }
        li:last-child {
          border: none;
        }
      }
      .el-menu {
        > li {
          .el-submenu__title {
            color: #409eff;
            border-bottom: 1px solid #c2c3c4;
            > i {
              color: #409eff;
            }
          }
          .el-menu-item-group__title {
            display: none;
          }
          &:nth-child(n+2) {
            .el-submenu__title {
              height: 35px;
              line-height: 35px;
              font-size: 12px;
            }
          }
          &:first-child {
            .el-submenu__title {
              height: 40px;
              line-height: 40px;
              font-size: 14px;
            }
          }
          > ul {
            li.el-menu-item {
              height: 25px;
              line-height: 25px;
              &:hover {
                background-color: #DEF0FF;

                .el-icon-right {
                  color: #BBD2E3;
                }
              }
            }
            li.is-active {
              background-color: #E2F1FE;

              .add-requirement{
                display: inline-block;
                line-height: 25px;
              }

              &:hover {
                background-color: #E2F1FE;

                .add-requirement{
                  display: inline-block;
                  line-height: 25px;
                }

                .el-icon-right {
                  color: #54ABF1;
                }
              }

              .el-icon-right {
                color: #54ABF1;
              }
            }
          }
        }
      }
    }
    .bottom-button{
      height: 50px;
      text-align: center;
      .reset{
        width: 85px;
        height: 25px;
        line-height: 25px;
        text-align: center;
        margin: 0 auto;
        box-sizing: border-box;
        border: 1px solid #65bce2;
        color: #65bce2;
        border-radius: 3px;
      }
      .reset:active{
        border: 1px solid #439ae0;
        color: #439ae0;
      }
    }
    .choose-table {
      margin-left: 10px;
      height: calc(100% - 15px);
      overflow-y: auto;
      padding-top: 12px;
      li {
        line-height: 28px;
        height: 28px;
        width: 226px;
        margin-bottom: 10px;
        background-color: #edf6ff;
        &:last-of-type {
          margin-bottom: 0;
        }
        .text {
          padding-left: 14px;
        }
        &:hover {
          background: #ecf5ff
        }
      }
      & > li {
        .text {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: inline-block;
          width: calc(100% - 10px);
        }
      }
      .data-list-ralation {
        width: 210px;
        margin-left: 7px;
        .el-form {
          margin-top: 10px;
          .el-select {
            width: 210px;
            margin-bottom: 15px;
          }
        }
      }
      .choose-table-item {
        cursor: pointer;
        position: relative;
        &:hover {
          background-color: #D6EBFC;
        }
        .choose-table-item-operation {
          position: absolute;
          top: 0;
          right: 10px;
          display: none;
          .el-icon-edit, .el-icon-close {
            color: #C2C3C4;
          }
          .el-icon-edit {
            margin-right: 5px;
            &:hover {
              color: #8ECAF9;
            }
            &:active {
              color: #388DD2;
            }
          }
          .choose-table-item-operation-delete {
            &:hover {
              .el-icon-error {
                display: inline-block;
              }
              .el-icon-close {
                display: none;
              }
            }
          }
          .el-icon-error {
            display: none;
            color: #FB9391;
            &:active {
              color: #EE5451;
            }
          }
        }
        &:hover {
          .choose-table-item-operation {
            display: inline-block;
          }
        }
        & > label {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: inline-block;
          width: calc(100% - 50px);
        }
      }
      .choose-table-item-select {
        background-color: #C6E3FA;
        &:hover {
          background-color: #C6E3FA;
        }
        .choose-table-item-operation {
          display: inline-block;
        }
      }
    }

    .data-list-btn {
      height: 50px;
      bottom: 0;
      left: 0;
      right: 0;
      position: absolute;
      background: #fff;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      button.reset {
        width: 89px;
        height: 28px;
      }
    }
    .graph-setting {
      width: 100%;
      height: calc(100% - 18px);
      overflow: auto;
      .table-list-graph {
        min-height: 40px;
        cursor: pointer;
        .table-item {
          position: relative;
          height: 38px;
          color: #409EFF;
          padding-left: 17px;
          line-height: 38px;
          border-bottom: 1px solid #F1F1F1;
          .name {
            width: calc(100% - 40px);
          }
          &.b_2 {
            padding-left: 27px;
          }
          &.b_3 {
            padding-left: 37px;
          }
          &.b_4 {
            padding-left: 47px;
          }
        }
        .type-data-source {
          position: relative;
          &:hover {
            & > .operation-icon-container {
              display: inline-block;
            }
          }
        }
        .add-relevancy {
          text-align: center;
          margin: 8px 0 19px 0;
        }
      }
      .graph-details {
        padding: 0 17px;
        color: #1A1A1A;
        font-size: 12px;
        .add-dimension {
          width: 100%;
          height: 28px;
          line-height: 28px;
          text-align: center;
          border: 1px dashed #C2C3C4;
          border-radius: 4px;
          margin: 8px 0 17px 0;
          cursor: pointer;
          position: relative;
          .el-icon-plus {
            margin-right: 4px;
          }
          .tables-column-list {
            position: absolute;
            top: 32px;
            z-index: 999;
            width: 100%;
            height:190px;
            background: #fff;
            border: 1px solid rgba(238, 241, 243, 1);
            box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.09);
            border-radius: 4px;
            overflow: auto;
            text-align: left;
            padding: 3px 0;
            .none {
              position: absolute;
              color: #999;
              top: 35%;
              left: 40%;
            }
          }
        }
        .system-default-filter {
          color: #7F8184;
          margin-bottom: 12px;
        }
        .expression {
          .filter-express {
            margin-right: 28px;
          }
          .filter-senior {
            .panel-title {
              .el-form {
                .type-filter {
                  .el-col-14 {
                    padding: 0 0 6px 25px !important;
                  }
                }
              }
            }
          }
         }
        .select-add-btn {
          background-color: #ebf6ff;
          color: #54ABF1;
          border-color: #54ABF1;
        }
        .disabled-add-btn {
          background-color: #f4f4f5;
          color: #999;
          border-color: #999;
        }
        .column-list-item {
          width: 100%;
          position: relative;
          color: #333;
          padding: 0 12px;
          height: 28px;
          .el-icon-check {
            position: absolute;
            right: 0;
            top: 6px;
            display: none;
          }
          &:hover {
            background-color: #ECF5FF;
          }
          & > span {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
            width: 100%;
          }
        }
        .select-column-item {
          color: #54ABF1;
          .el-icon-check {
            display: inline-block;
          }
        }
        .disabled-column-item {
          color: #999;
        }
        .graph-attr-list {
          width: 100%;
          height: 28px;
          padding: 0 11px;
          line-height: 28px;
          border: 1px solid #C2C3C4;
          border-radius: 4px;
          margin-bottom: 10px;
          cursor: pointer;
          position: relative;
          .operation-graph-container {
            position: absolute;
            right: 12px;
            display: none;
            span {
              color: #D5D6D9;
            }
            .el-icon-edit {
              &:hover {
                color: #8ECAF9;
              }
              &:active {
                color: #388DD2;
              }
            }
            .el-icon-error {
              &:hover {
                color: #FB9391;
              }
              &:active {
                color: #EE5451;
              }
            }
            .disabled-icon-edit {
              color: #D5D6D9;
              &:hover, &:active, &:focus {
                color: #D5D6D9;
              }
            }
          }
          &:hover {
            > .operation-graph-container {
              display: inline-block;
            }
          }
          .edit-dialog-warp {
            position: absolute;
            z-index: 999;
            top: 30px;
            right: 0;
            width: 178px;
            height: 118px;
            background: #fff;
            border: 1px solid rgba(238,241,243,1);
            box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.09);
            border-radius: 4px;
            padding: 0 9px;
            .edit-dialog-title {
              font-size: 12px;
              color: #333;
              .el-icon-info {
                color: #C2C3C4;
                font-size: 12px;
                &:hover {
                  color: #54ABF1;
                }
              }
            }
            .edit-dialog-footer {
              padding-top: 22px;
              text-align: center;
            }
          }
          .graph-index-dialog {
            height: 237px;
          }
        }
        .graph-title {
          margin-bottom: 9px;
        }
        .active-graph-list {
          border-color: #54ABF1;
          .operation-graph-container {
            display: inline-block;
          }
        }
        .billboard-line{
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 12px;
          label{
            width: 65px;
          }
          .el-input{
            width: 135px;
          }
          .el-tooltip {
            color: rgb(192,194,193);
            cursor: pointer;
            &:hover{
              color: #3a8ee6;
            }
          }
        }
        .billboard-line:nth-child(1){
          margin-top: 12px;
        }
      }
      .dimensionSearch{
        height: 30px;
        line-height: 30px;
      }
      .list-content{
        overflow: auto;
        height: 150px;
      }
    }
    .save-graph {
      padding-top: 6px;
      text-align: center;
      .el-button {
        padding: 0;
        height: 26px;
        width: 78px;
        line-height: 26px;
      }
    }
    span {
      white-space: nowrap;
    }
  }
 .without-tip-dialog{
    width: 136px;
    height: 36px;
    position: fixed;
    background-color: #29282E;
    opacity: 0.65;
    text-align: center;
    line-height: 36px;
    border-radius: 4px;
    z-index: 10;
    >p{
      font-size: 12px;
      color: #FFFFFF;
    }

}

</style>



// WEBPACK FOOTER //
// src/components/report/design/report-data-list.vue